import { Swiper, SwiperSlide } from 'swiper/react';
import { Scrollbar, Pagination, Autoplay } from 'swiper';
import EFPicture from '@elem/compCommon/EFPicture';
import css from './index.module.scss';

const animationId: any = null;
const duration = 4000; // 动画持续时间（毫秒）
const initAniTime = 0; // 开启动画的时间
const aniFrameTime = 0; // 每一帧动画进入时间
const pause = false; // 用户交互鼠标移入是否暂停
const percent = 0; // 进度
const replay = false; // 暂停后继续播放
const enterTime = 0; // 鼠标移入时间
const leaveTime = 0; // 鼠标移出时间
export default function H5Com({ title, subtitle, desc, tips, cls, imgArr, imgArrInfo }: any) {
    // console.log(imgArr);
    return (
        <div className={`h5-com ${css['h5-com']}`}>
            <h2 className="dp3-title">{title}</h2>
            <Swiper
                className={`swiper-box ${imgArr?.length === 1 ? 'single' : ''}`}
                modules={[Scrollbar, Pagination, Autoplay]}
                // autoplay={{
                //     delay: 3000,
                //     disableOnInteraction: false,
                //     pauseOnMouseEnter: true,
                // }}
                // navigation={true}
                pagination={
                    imgArr?.length > 1
                        ? {
                              clickable: true,
                          }
                        : false
                }
                loop={imgArr?.length > 1}
                spaceBetween={0}
                // centeredSlides={true}
                slidesPerView={'auto'}
                initialSlide={0}
            >
                {imgArr?.map((img: any, k: number) => (
                    <SwiperSlide className={`swiper-item`} key={k}>
                        <EFPicture src={img} alt={title} />
                        {imgArrInfo && imgArrInfo[k] && (
                            <div className="img-info">
                                {imgArrInfo[k]?.hasTitleSvg && imgArrInfo[k]?.titleSvg}
                                {imgArrInfo[k]?.title && <p className="img-title">{imgArrInfo[k]?.title}</p>}
                                {imgArrInfo[k]?.desc && <p className="img-desc">{imgArrInfo[k]?.desc}</p>}
                            </div>
                        )}
                    </SwiperSlide>
                ))}
            </Swiper>
            <div className="info-box">
                <p className="subtitle">{subtitle}</p>
                <p className="desc">
                    {desc}
                    <span className="tips">{tips}</span>
                </p>
            </div>
        </div>
    );
}
